import commonApi from "./CommonApi.js";

export default {
	getAll: async (parameter) => {
		return await commonApi().get("/v1/admin/nationalForumSettings/getAll", { params: parameter })
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/admin/nationalForumSettings', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
}